import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import TeacherToolCard from '../../components/compositions/TeacherToolCard/TeacherToolCard';
import TeacherLayoutWrapper from '../../components/layouts/TeacherLayoutWrapper/TeacherLayoutWrapper';
import './teacher-tools-view.scss';
import { getTeacherTools } from './teacherToolsConfig';

const TeacherToolsView = () => {
  const { t } = useTranslation(['chatbot']);
  const history = useHistory();
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  // Get the tools configuration
  const tools = getTeacherTools(t);

  const onShowMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
    if (!showMobileMenu) {
      document.body.style.overflowY = 'hidden';
    } else {
      document.body.style.overflowY = 'scroll';
    }
  };

  // Navigate to tool-specific setup
  const handleToolClick = (tool) => {
    history.push(`/ai/tools/setup/${tool.id}`);
  };

  return (
    <TeacherLayoutWrapper activeNavigationId="tools" showMobileMenu={showMobileMenu} onShowMobileMenu={onShowMobileMenu} className="teacher-tools-view">
      <div className="teacher-tools-view__content">
        {/* Section Title */}
        <div className="teacher-tools-view__header">
          <h3 className="teacher-tools-view__title">{t('teacher_tools_title')}</h3>
        </div>

        <div className="teacher-tools-view__description-container">
          <div className="teacher-tools-view__description-image" />
          <p className="teacher-tools-view__description">{t('teacher_tools_description')}</p>
        </div>

        {/* Tools Grid */}
        <div className="teacher-tools-view__grid">
          {tools.map((tool) => (
            <TeacherToolCard key={tool.id} tool={tool} onClick={() => handleToolClick(tool)} />
          ))}
        </div>
      </div>
    </TeacherLayoutWrapper>
  );
};

export default TeacherToolsView;
